<template>
  <div class="hris-page">
    <div class="hris-page-inner">
      <div class="hris-page-header hris-page-header-row">
        <div>
          <span class="hris-page-eyebrow">Employee Reports</span>
          <h1 class="hris-page-title">Trainee List</h1>
          <p class="hris-page-subtitle">Manage trainee records, import data, and track hold status.</p>
        </div>
        <div class="row q-gutter-sm">
          <q-btn unelevated class="hris-q-primary" label="Import" @click="importTrainees"></q-btn>
          <q-btn unelevated class="hris-q-outline" label="Template" @click="getTemplate"></q-btn>
        </div>
      </div>

      <div class="hris-panel">
        <q-table
          :dense="$q.screen.lt.md"
          :grid="$q.screen.xs"
          :data="trainees"
          :columns="columns"
          row-key="id"
          separator="cell"
          no-data-label="I didn't find anything for you!"
          :pagination.sync="pagination"
          :loading="loading"
          :filter="filter"
          @request="onRequest"
          binary-state-sort
          flat
        >
          <template v-slot:body="props">
            <q-tr slot="body" :props="props">
              <q-td key="tid" :props="props">{{ props.row.tid }}</q-td>
              <q-td key="fname" :props="props">{{ props.row.fname }}</q-td>
              <q-td key="lname" :props="props">{{ props.row.lname }}</q-td>
              <q-td key="department" :props="props">{{ props.row.department }}</q-td>
              <q-td key="max_credit" :props="props">{{ props.row.max_credit }}</q-td>
              <q-td key="is_hold" :props="props">
                <span class="hris-badge hris-badge-success" v-show="props.row.is_hold == 'N'">Active</span>
                <span class="hris-badge hris-badge-warning" v-show="props.row.is_hold == 'Y'">Hold</span>
              </q-td>
              <q-td key="reason" :props="props">{{ props.row.reason }}</q-td>
              <q-td key="action" :props="props">
                <div class="row q-gutter-sm justify-center">
                  <q-btn outline dense class="hris-q-outline" size="sm" label="Edit" @click="editEmployee(props.row)"></q-btn>
                  <q-btn outline dense class="hris-q-outline" size="sm" style="color: #a61b12; border-color: rgba(193, 50, 50, 0.35);" label="Delete" @click="deleteEmployee(props.row)"></q-btn>
                  <q-btn outline dense class="hris-q-outline" size="sm" :label="props.row.is_hold == 'N' ? 'Hold' : 'Unhold'" @click="holdEmployee(props.row)"></q-btn>
                </div>
              </q-td>
            </q-tr>
          </template>
          <template v-slot:no-data="">
            <div class="hris-empty full-width">The filter didn't uncover any results.</div>
          </template>
          <template v-slot:loading>
            <q-inner-loading showing>
              <div class="hris-loading">
                <q-spinner color="green" size="40px"></q-spinner>
                <span>Loading trainees...</span>
              </div>
            </q-inner-loading>
          </template>
          <template v-slot:top-right="props">
            <q-input dense outlined color="green" v-model="filter" placeholder="Search Trainee">
              <template v-slot:append>
                <q-icon name="fas fa-search"></q-icon>
              </template>
            </q-input>
          </template>
        </q-table>
      </div>

      <HoldDialog></HoldDialog>
      <DeleteDialog></DeleteDialog>
      <EditDialog></EditDialog>
      <ImportDialog></ImportDialog>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import mixins from '../../mixins';
import HoldDialog from './HoldDialog';
import DeleteDialog from './DeleteDialog';
import EditDialog from './EditDialog';
import ImportDialog from './ImportDialog';
export default {
  name: 'TraineeList',
  components: {
    "HoldDialog": HoldDialog,
    "DeleteDialog": DeleteDialog,
    "EditDialog": EditDialog,
    "ImportDialog": ImportDialog,
  },
  data() {
    return {
        filter: '',
        loading: false,
        pagination: {
            page: 1,
            rowsPerPage: 15,
            rowsNumber: 10
        },

      importfile: false,
      isHold:false,
      columns: [
      { name: 'tid', align: 'center', label: 'Trainee ID', field: 'tid', sortable: true },
      { name: 'fname', align: 'center', label: 'First Name', field: 'fname', sortable: true },
      { name: 'lname', align: 'center', label: 'Last Name', field: 'lname', sortable: true },
      { name: 'department', align: 'center', label: 'Department', field: 'department', sortable: true },
      { name: 'max_credit', align: 'center', label: 'Max Credit', field: 'max_credit', sortable: true },
      { name: 'is_hold', align: 'center', label: 'Status', field: 'is_hold', sortable: true },
      { name: 'reason', align: 'center', label: 'Hold Reason', field: 'reason', sortable: true },
      { name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
      ],
      trainees: [],
    }

  },

  created() {
     this.eventHub.$on('refreshList', this.getEmployees);
    this.getEmployees()
  },


  methods: {

     getTemplate(){
       this.downloadTemplate('uploads/template/trainee_template.csv','TraineeTemplate')
     },

      //start if server side
      onRequest (props) {
        const { page, rowsPerPage } = props.pagination
        const filter = props.filter
        this.loading = true
        setTimeout(() => {
          this.getRowsNumberCount(filter).then(total => {
              this.pagination.rowsNumber = total
          })
          const fetchCount = rowsPerPage === 0 ? this.pagination.rowsNumber : rowsPerPage
          const startRow = (page - 1) * rowsPerPage
          this.fetchFromServer(startRow, fetchCount, filter)
          this.pagination.page = page
          this.pagination.rowsPerPage = rowsPerPage
        }, 1500)
      },

      fetchFromServer (startRow, count, filter) {
          axios.get(this.apiUrl + '/mobile/pantry/trainee/list', {
              headers: { 'Authorization': `Bearer ${this.token}` },
              params: {
                start: startRow,
                countPerPage: count,
                filter: filter,
              }
          }).then((response) => {
              this.trainees = response.data
              this.loading = false
          }).catch((error) => {
              console.log(error);
          })
     },

      async getRowsNumberCount (filter) {
         let response = await axios.get(this.apiUrl + '/mobile/pantry/trainee/count', {
             headers: { 'Authorization': `Bearer ${this.token}` },
             params: {
                filter: filter,
             }
         })
         return response.data
      },

      ///end of server side

    getEmployees: function() {
         this.onRequest({pagination:this.pagination,filter:''})
    },

    onSubmit:function(){
      let formData  = new FormData();
      formData.append("files", this.file);
      axios({
         onUploadProgress: uploadEvent => {
           console.log("Progress: " + Math.round(uploadEvent.loaded / uploadEvent.total * 100) + '%')
         },
         headers : {'Authorization' : `Bearer ${this.token}`},
         url:this.apiUrl+'/employee/import-account',
         data: formData,
         method: 'POST'
      }).then(response => {
         console.log(this.token)
         console.log('tes',response)

         setTimeout(() => {
           this.importfile = false
         },500)
         this.$q.notify({
             message: 'Successful',
             color: 'green',
             position:'center',
             actions: [
               { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
             ]
         })
      }).catch((error) => {
         var message = error.response.data.exception[1].message
         var index = message.indexOf("1062");
         var final = message.substring(index + 4);
         this.$q.notify({
           message: final,
           color: 'negative',
           position:'center',
           actions: [
             { label: 'Dismiss', color: 'white', handler: () => { /* ... */ } }
           ]
         })
      })
    },

  downloadTemplate: function(url,filename) {
    axios({
      url: this.apiUrl + '/' + url,
      method: 'GET',
      responseType: 'arraybuffer',
    }).then((response) => {
      var fileURL = window.URL.createObjectURL(new Blob([response.data]));
      var fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', `${filename}.csv`);
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  },

  importTrainees: function() {
    this.eventHub.$emit('importFileDialog', { status: true });
  },

  editEmployee:function(obj){
     this.eventHub.$emit('editEmployee', { status: true,obj:obj});
  },

  deleteEmployee:function(obj){
     this.eventHub.$emit('deleteEmployee', { status: true,id:obj.id});
  },

   holdEmployee:function(obj){
      this.eventHub.$emit('holdEmployee', { status: true,id:obj.id,isHold:obj.is_hold });
   }
}
}
</script>
<style lang="css" scoped>
</style>
